import { request } from '@tencent/ppd-base-libs';
import { cacheFunc } from '@tencent/wphk-base-utils';
import dayjs from 'dayjs';
import { ConfigParams, NoticeConfig } from './type';

/** 灰度配置链接前缀，例如业务是 balance, 则完整链接是 https://st.moneydata.hk/res/cc/noticeConfig/balance.json  */
const NOTICE_CONFIG_URL_PREFIX = 'https://st.moneydata.hk/res/cc/noticeConfig/';

/** 获取配置的请求方法 */
const requestConfig = (business: string): Promise<NoticeConfig[]> => request.loadVtools(`${NOTICE_CONFIG_URL_PREFIX}/${business}.json`).then(res => res.map(item => ({
  ...item,
  startTime: dayjs(item.startTime).toDate(),
  endTime: dayjs(item.endTime).toDate(),
})));

const cacheRequestConfig = cacheFunc(requestConfig);

/** 获取当前业务、页面下的公告配置 */
export const getConfig = async (params: ConfigParams) => {
  const { business, page: name, filterConfigFunc = defaultConfigFilter } = params;
  const allConfigs = await cacheRequestConfig(business);
  // 首先筛选出
  const configs = baseConfigFilter(allConfigs, name);
  return filterConfigFunc(configs);
};

/** 检查公告是否为阻断型 */
export const isBlocked = async (params: ConfigParams) => getConfig(params).then(config => config.isBlocked);

/**
 * 基础的filter函数，筛选出名称一致、已上线、且生效日期有效的公告数组
 * */
const baseConfigFilter = (
  configs: NoticeConfig[],
  name: string,
) => configs.filter(item => item.isOnline
  // 比较是否包含名称
  && item.page === name
  // 比较完名称后，检查当前日期是否在范围内
  && item.startTime <= new Date()
  && item.endTime >= new Date());

export const defaultConfigFilter = (configs: NoticeConfig[]) => configs[0];
